import { createFileRoute } from "@tanstack/react-router";
import { BillingSettingsPage } from "../../features/billing/settings-page";

export const Route = createFileRoute("/billing/settings")({ component: BillingSettingsPage });
